import { render, staticRenderFns } from "./AliJapan.vue?vue&type=template&id=4de88e4e&"
import script from "./AliJapan.vue?vue&type=script&lang=ts&"
export * from "./AliJapan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports